// export const environment = {
//   production: false,
//   BACKEND_URL: 'http://localhost:3500/api',
//   OFFER_DARTE:"25-05-2026",
//   // BACKEND_URL: 'https://aisslo-api.kishul.com/api',
//   // BACKEND_URL: 'https://api-dev.aisslo.com/api',
//   // TODO: when deployed on aisslo.kishul.com, on completion of the payment,
//     // the user is redirected to localhost:4200 instead of aisslo.kishul.com.
//     // Please create a variable as STRIPE_CALLBACK and use that.
//   // STRIPE_PUBLISHABLE_KEY:'pk_test_51QD7K2LzYaFdlbgfXCmvhZna68Pjqo2E1dO9EF5Ome7QaPUV0hM1vWBtmcQ2ueVB1bn4dsmzxMuIdSfw79iwpNQp00idnabAvQ',
//   // MOKHS'S TEST
//   // STRIPE_PUBLISHABLE_KEY:'sk_test_51QD7K2LzYaFdlbgfBwmvhm4FAKIQrQtNzHYerHy0bFPJ22hkwPslaEgNKNY7TbRWcmFsUxsrOHQ8851p6wLY6gsG00lp2xPOtD',
//   //AISSLO TEST
//   STRIPE_PUBLISHABLE_KEY:'pk_test_51ReUxzSAuJeMgqWpWJzbUfKxoHWtptL4juBjIfyCf4OjdCfU2MV3Z1nlFBs2BX94BnmXhk0bsaJ4PAfALoh9G8Dd00E8J5KQ1F',
//      clientId:'1065061478138-89n9d1bn2qraf78v58d2b3koueps6v23.apps.googleusercontent.com'
// };
export const environment = {
  production: false,
BACKEND_URL: "https://api.aisslo.com/api",
//  BACKEND_URL: 'http://localhost:3500/api',
OFFER_DARTE: "15-JAN-2026",
STRIPE_PUBLISHABLE_KEY: "pk_live_51QhBCYI0AiZBEKu1fwDbXgEy4pMdF80QbzzCxyH6kz4uxN6mpo982qmtt9Ij7cT3ufC4ZNxtOORWQWon5wfb2Czk00D5NiX6gv",
clientId: "1065061478138-89n9d1bn2qraf78v58d2b3koueps6v23.apps.googleusercontent.com",
};